import React, { useRef } from "react";
import { NiceModal } from "@castlery/fortress";
import { trackEvent } from "@/utils/analytics";

interface GladlyAppProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
  containerRef?: React.RefObject<HTMLDivElement>;
}

export const GladlyApp: React.FC<GladlyAppProps> = ({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  onClose,
  containerRef,
}) => {
  const isCanceling = useRef(false);

  const handleConfirm = () => {
    trackEvent({
      event: "gladly_handoff_confirm_button_click",
      category: "gladly_handoff",
      action: "click",
    });

    onConfirm();
    onOpenChange(false);
  };

  const handleCancel = () => {
    if (isCanceling.current) return;
    isCanceling.current = true;

    trackEvent({
      event: "gladly_handoff_cancel_button_click",
      category: "gladly_handoff",
      action: "click",
    });

    onCancel();
    onOpenChange(false);
  };

  const handleClose = () => {
    if (isCanceling.current) {
      isCanceling.current = false;
      return;
    }

    trackEvent({
      event: "gladly_handoff_close_button_click",
      category: "gladly_handoff",
      action: "click",
    });

    onClose();
    onOpenChange(false);
    isCanceling.current = true;
  };

  return (
    <NiceModal
      title="Start a chat with customer service"
      open={open}
      onClose={handleClose}
      isSilent={false}
      onConfirm={handleConfirm}
      confirmText="CONFIRM"
      onCancel={handleCancel}
      cancelText="CANCEL"
      container={containerRef?.current}
      disableEnforceFocus={true}
      modalSlotProps={{
        backdrop: { sx: { position: "absolute", inset: 0 } },
        root: { sx: { position: "absolute", inset: 0 } },
      }}
      dialogSx={{
        maxWidth: "90%",
      }}
    />
  );
};
